module.exports = {
  eventCategory: 'Editor UI | Tool Menu | customize | stickers',

  render: function () {
    this.trackEvent({
      eventAction: 'show',
      eventLabel: this.category.id
    });
  }
};
